<div class="form-section">
  <div class="section-header">
    <div class="section-label">
      <span class="section-num">03.A</span>
      <span class="section-title">Linked surveys</span>
    </div>
    <span class="section-hint">{{ linkedSurveys.length }} active</span>
  </div>

  <div class="surveys-list">
    @for (survey of linkedSurveys; track survey.id) {
    <div class="survey-card">
      <div class="survey-card-icon">
<img src="assets/icons/survey_primary.svg" alt="Surveys" width="32" height="32" />
      </div>
      <div class="survey-card-body">
        <div class="survey-card-name">{{ survey.name }}</div>
        <div class="survey-card-meta">
          <span class="survey-trigger-badge" [class]="getSurveyTriggerClass(survey.trigger)">
            {{ getSurveyTriggerLabel(survey.trigger) }}
          </span>
          @if (survey.meta) {
            <span class="survey-card-info">· {{ survey.meta }}</span>
          }
        </div>
      </div>
      <button class="open-btn" (click)="unlinkSurvey(survey.id)" title="Open survey">
<span class="open-text">Open</span>
      </button>
    </div>
    }

    <!-- <div class="survey-picker-wrapper">
      <button class="add-survey-btn" (click)="showSurveyPicker = !showSurveyPicker">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M6 2v8M2 6h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        Link survey
      </button>
      @if (showSurveyPicker) {
      <div class="survey-picker">
        @if (unlinkedAvailableSurveys.length === 0) {
          <div class="survey-picker-empty">All available surveys are already linked.</div>
        } @else {
          @for (s of unlinkedAvailableSurveys; track s.id) {
          <button class="survey-picker-item" (click)="linkSurvey(s)">
            <div class="survey-picker-name">{{ s.name }}</div>
            <span class="survey-trigger-badge" [class]="getSurveyTriggerClass(s.trigger)">
              {{ getSurveyTriggerLabel(s.trigger) }}
            </span>
          </button>
          }
        }
      </div>
      }
    </div> -->
  </div>
</div>

<div class="section-divider"></div>
